<template>
  <div class="vip-redeem-admin-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/menu/welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统服务</el-breadcrumb-item>
      <el-breadcrumb-item>VIP兑换码</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="vip-redeem-admin-page__card">
      <div slot="header" class="vip-redeem-admin-page__header">
        <div>
          <div class="vip-redeem-admin-page__title">康复指导 VIP 兑换码生成</div>
          <div class="vip-redeem-admin-page__subtitle">按商户生成独立兑换码，支持设置有效期、VIP 月数与康复指导次数。</div>
        </div>
        <el-tag type="warning">系统类型：{{ systemType }}</el-tag>
      </div>

      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="商户号" prop="merchantCode">
              <el-input v-model.trim="form.merchantCode" placeholder="例如：jiumiao"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="生成数量" prop="count">
              <el-input-number v-model="form.count" :min="1" :max="5000" :step="10" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="有效期(月)" prop="expireMonths">
              <el-input-number v-model="form.expireMonths" :min="1" :max="36" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="VIP月数" prop="vipMonths">
              <el-input-number v-model="form.vipMonths" :min="1" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="指导次数" prop="serviceCount">
              <el-input-number v-model="form.serviceCount" :min="0" :max="99" controls-position="right"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8" class="vip-redeem-admin-page__actions-col">
            <el-button :loading="submitting" type="primary" @click="submitGenerate">立即生成</el-button>
            <el-button :loading="recordsLoading" @click="loadRecords">刷新核销记录</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="vip-redeem-admin-page__card">
      <div slot="header" class="vip-redeem-admin-page__section-header">
        <span>最近生成批次</span>
        <div class="vip-redeem-admin-page__section-actions">
          <el-select
            v-model="batchMerchantCode"
            class="vip-redeem-admin-page__record-search"
            clearable
            filterable
            remote
            reserve-keyword
            placeholder="请选择商户号"
            :remote-method="searchMerchantCodes"
            :loading="merchantOptionsLoading"
          >
            <el-option
              v-for="item in merchantOptions"
              :key="item"
              :label="item"
              :value="item"
            ></el-option>
          </el-select>
          <el-button :loading="batchLoading" size="mini" type="primary" @click="loadLatestBatches">查询批次</el-button>
        </div>
      </div>

      <el-table v-loading="batchLoading" :data="latestBatches" border stripe @row-click="selectBatch">
        <el-table-column label="批次号" min-width="180" prop="batchNo"></el-table-column>
        <el-table-column label="商户号" min-width="120" prop="merchantCode"></el-table-column>
        <el-table-column label="数量" min-width="90" prop="count"></el-table-column>
        <el-table-column label="VIP月数" min-width="90" prop="vipMonths"></el-table-column>
        <el-table-column label="指导次数" min-width="90" prop="serviceCount"></el-table-column>
        <el-table-column label="过期时间" min-width="160">
          <template slot-scope="scope">{{ formatDateTime(scope.row.expireTime) }}</template>
        </el-table-column>
        <el-table-column label="生成时间" min-width="160">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createTime) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="220">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click.stop="loadBatchDetail(scope.row)">查看批次</el-button>
            <el-button size="mini" type="text" @click.stop="exportBatchExcel(scope.row)">导出Excel</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-card v-if="generateResult" class="vip-redeem-admin-page__card vip-redeem-admin-page__result">
      <div slot="header" class="vip-redeem-admin-page__section-header">
        <span>{{ resultTitle }}</span>
        <div class="vip-redeem-admin-page__section-actions">
          <el-button plain size="mini" type="primary" @click="copyCodes">复制全部兑换码</el-button>
          <el-button plain size="mini" type="success" @click="exportCurrentExcel">导出Excel</el-button>
        </div>
      </div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="商户号">{{ generateResult.merchantCode }}</el-descriptions-item>
        <el-descriptions-item label="批次号">{{ generateResult.batchNo }}</el-descriptions-item>
        <el-descriptions-item label="生成数量">{{ generateResult.count }}</el-descriptions-item>
        <el-descriptions-item label="过期时间">{{ formatDateTime(generateResult.expireTime) }}</el-descriptions-item>
        <el-descriptions-item label="VIP月数">{{ generateResult.vipMonths }} 个月</el-descriptions-item>
        <el-descriptions-item label="指导次数">{{ generateResult.serviceCount }} 次</el-descriptions-item>
      </el-descriptions>

      <div class="vip-redeem-admin-page__codes">
        <div class="vip-redeem-admin-page__codes-title">兑换码列表</div>
        <el-tag v-for="code in generateResult.codes" :key="code" class="vip-redeem-admin-page__code-tag" effect="dark" type="warning">{{ code }}</el-tag>
      </div>
    </el-card>

    <el-card class="vip-redeem-admin-page__card">
      <div slot="header" class="vip-redeem-admin-page__section-header">
        <span>核销记录</span>
        <div>
          <el-input v-model.trim="recordMerchantCode" class="vip-redeem-admin-page__record-search" placeholder="输入商户号查看核销记录"></el-input>
          <el-button :loading="recordsLoading" size="mini" type="primary" @click="loadRecords">查询</el-button>
        </div>
      </div>

      <el-table v-loading="recordsLoading" :data="records" border stripe>
        <el-table-column label="兑换码" min-width="180" prop="code"></el-table-column>
        <el-table-column label="商户号" min-width="120" prop="merchantCode"></el-table-column>
        <el-table-column label="用户ID" min-width="120" prop="userId"></el-table-column>
        <el-table-column label="手机号" min-width="120" prop="phone"></el-table-column>
        <el-table-column label="VIP月数" min-width="90" prop="vipMonths"></el-table-column>
        <el-table-column label="指导次数" min-width="90" prop="serviceCount"></el-table-column>
        <el-table-column label="开通时间" min-width="160">
          <template slot-scope="scope">{{ formatDateTime(scope.row.vipStartTime) }}</template>
        </el-table-column>
        <el-table-column label="到期时间" min-width="160">
          <template slot-scope="scope">{{ formatDateTime(scope.row.vipEndTime) }}</template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import { REHAB_GUIDANCE_SYSTEM_TYPE } from '@/constants/systemConfig'

export default {
  name: 'VipRedeemAdminPage',
  data () {
    return {
      systemType: REHAB_GUIDANCE_SYSTEM_TYPE,
      submitting: false,
      recordsLoading: false,
      batchLoading: false,
      generateResult: null,
      resultTitle: '最近一次生成结果',
      form: {
        merchantCode: '',
        count: 20,
        expireMonths: 3,
        vipMonths: 60,
        serviceCount: 1
      },
      recordMerchantCode: '',
      batchMerchantCode: '',
      merchantOptionsLoading: false,
      merchantOptions: [],
      records: [],
      latestBatches: [],
      rules: {
        merchantCode: [
          { required: true, message: '请输入商户号', trigger: 'blur' }
        ],
        count: [
          { required: true, message: '请输入生成数量', trigger: 'change' }
        ],
        expireMonths: [
          { required: true, message: '请输入有效期', trigger: 'change' }
        ],
        vipMonths: [
          { required: true, message: '请输入VIP月数', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.searchMerchantCodes('')
  },
  methods: {
    submitGenerate () {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const { data: resp } = await this.$http.post('/vip/redeem-code/batch-generate', this.form)
          if (!resp || resp.code !== 200) {
            return this.$message.error(resp?.message || '生成失败')
          }
          this.generateResult = resp.data
          this.resultTitle = '最近一次生成结果'
          this.recordMerchantCode = this.form.merchantCode
          this.batchMerchantCode = this.form.merchantCode
          if (this.form.merchantCode && !this.merchantOptions.includes(this.form.merchantCode)) {
            this.merchantOptions = [this.form.merchantCode].concat(this.merchantOptions)
          }
          this.$message.success(`成功生成 ${resp.data.count} 个兑换码`)
          this.loadRecords()
          this.loadLatestBatches()
        } catch (error) {
          const message = error?.response?.data?.message || error?.message || '生成失败，请稍后重试'
          this.$message.error(message)
        } finally {
          this.submitting = false
        }
      })
    },
    async loadRecords () {
      const merchantCode = (this.recordMerchantCode || this.form.merchantCode || '').trim()
      if (!merchantCode) {
        this.records = []
        return this.$message.warning('请先输入商户号')
      }
      this.recordsLoading = true
      try {
        const { data: resp } = await this.$http.get('/vip/redeem-code/records', {
          params: { merchantCode }
        })
        if (!resp || resp.code !== 200) {
          return this.$message.error(resp?.message || '获取核销记录失败')
        }
        this.records = Array.isArray(resp.data) ? resp.data : []
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || '获取核销记录失败'
        this.$message.error(message)
      } finally {
        this.recordsLoading = false
      }
    },
    async loadLatestBatches () {
      const merchantCode = (this.batchMerchantCode || this.form.merchantCode || '').trim()
      if (!merchantCode) {
        this.latestBatches = []
        return this.$message.warning('请先选择商户号')
      }
      this.batchLoading = true
      try {
        const { data: resp } = await this.$http.get('/vip/redeem-code/latest-batches', {
          params: { merchantCode, limit: 10 }
        })
        if (!resp || resp.code !== 200) {
          return this.$message.error(resp?.message || '获取批次失败')
        }
        this.latestBatches = Array.isArray(resp.data) ? resp.data : []
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || '获取批次失败'
        this.$message.error(message)
      } finally {
        this.batchLoading = false
      }
    },
    async searchMerchantCodes (keyword) {
      this.merchantOptionsLoading = true
      try {
        const { data: resp } = await this.$http.get('/vip/redeem-code/merchant-codes', {
          params: { keyword: keyword || '' }
        })
        if (!resp || resp.code !== 200) {
          return this.$message.error(resp?.message || '获取商户号失败')
        }
        this.merchantOptions = Array.isArray(resp.data) ? resp.data : []
      } catch (error) {
        const message = error?.response?.data?.message || error?.message || '获取商户号失败'
        this.$message.error(message)
      } finally {
        this.merchantOptionsLoading = false
      }
    },
    async loadBatchDetail (batch) {
      const { data: resp } = await this.$http.get('/vip/redeem-code/batch-detail', {
        params: {
          merchantCode: batch.merchantCode,
          batchNo: batch.batchNo
        }
      })
      if (!resp || resp.code !== 200) {
        throw new Error(resp?.message || '获取批次详情失败')
      }
      this.generateResult = resp.data
      this.resultTitle = `批次详情：${batch.batchNo}`
      return resp.data
    },
    selectBatch (batch) {
      this.loadBatchDetail(batch).catch(error => {
        const message = error?.response?.data?.message || error?.message || '获取批次详情失败'
        this.$message.error(message)
      })
    },
    copyCodes () {
      if (!this.generateResult || !Array.isArray(this.generateResult.codes) || !this.generateResult.codes.length) {
        return this.$message.warning('暂无可复制的兑换码')
      }
      const text = this.generateResult.codes.join('\n')
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$message.success('兑换码已复制')
        }).catch(() => {
          this.fallbackCopy(text)
        })
        return
      }
      this.fallbackCopy(text)
    },
    exportCurrentExcel () {
      if (!this.generateResult) {
        return this.$message.warning('暂无可导出的批次')
      }
      this.exportBatchData(this.generateResult)
    },
    exportBatchExcel (batch) {
      this.loadBatchDetail(batch).then(data => {
        this.exportBatchData(data)
      }).catch(error => {
        const message = error?.response?.data?.message || error?.message || '导出失败'
        this.$message.error(message)
      })
    },
    exportBatchData (batchDetail) {
      if (!batchDetail || !Array.isArray(batchDetail.codes) || !batchDetail.codes.length) {
        return this.$message.warning('该批次暂无可导出的兑换码')
      }
      const rows = batchDetail.codes.map((code, index) => ({
        序号: index + 1,
        商户号: batchDetail.merchantCode,
        批次号: batchDetail.batchNo,
        兑换码: code,
        VIP月数: batchDetail.vipMonths,
        指导次数: batchDetail.serviceCount,
        过期时间: this.formatDateTime(batchDetail.expireTime)
      }))
      const worksheet = XLSX.utils.json_to_sheet(rows)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, '兑换码')
      XLSX.writeFile(workbook, `${batchDetail.merchantCode}-${batchDetail.batchNo}.xlsx`)
      this.$message.success('Excel 已导出')
    },
    fallbackCopy (text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      textarea.style.position = 'fixed'
      textarea.style.opacity = '0'
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('兑换码已复制')
    },
    formatDateTime (value) {
      if (!value) return '--'
      const date = new Date(value)
      if (Number.isNaN(date.getTime())) return '--'
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hour = String(date.getHours()).padStart(2, '0')
      const minute = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}`
    }
  }
}
</script>

<style scoped>
.vip-redeem-admin-page {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.vip-redeem-admin-page__card {
  margin-top: 18px;
}

.vip-redeem-admin-page__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vip-redeem-admin-page__title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
}

.vip-redeem-admin-page__subtitle {
  margin-top: 6px;
  color: #6b7280;
  font-size: 13px;
}

.vip-redeem-admin-page__actions-col {
  display: flex;
  align-items: center;
  gap: 12px;
}

.vip-redeem-admin-page__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vip-redeem-admin-page__section-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vip-redeem-admin-page__codes {
  margin-top: 18px;
}

.vip-redeem-admin-page__codes-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.vip-redeem-admin-page__code-tag {
  margin-right: 10px;
  margin-bottom: 10px;
}

.vip-redeem-admin-page__record-search {
  width: 220px;
  margin-right: 8px;
}
</style>
